import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "../../App";
import "../../styles/Frontend/components.scss";

const Navbar = () => {
  const [navOpen, setNavOpen] = useState(false);
  const [authBtn, setAuthBtn] = useState(true);
  const { userData, setUserData } = useContext(UserContext);

  const logOut = () => {
    setUserData({
      token: undefined,
      user: undefined,
    });
    localStorage.setItem("auth-token", "");
    window.location.href = "/login";
  };

  useEffect(() => {
    const isLoggedIn = async () => {
      let token = localStorage.getItem("auth-token");
      if (token === "") {
        setAuthBtn(false);
      } else {
        setAuthBtn(true);
      }
    };

    isLoggedIn();
  }, []);

  const location = useLocation();

  return (
    <nav
      className={`navbar  home-nav
      ${
        location.pathname === "/register" || location.pathname === "/login"
          ? "bg-success"
          : "bg-dark"
      }
      `}
    >
      <div className="container inner">
        <Link to="/" className="logo-white">
          <img src="/imgs/logofull.png" alt="" />
        </Link>

        <div className={`custom-nav ${navOpen ? "mobile-nav" : ""}`}>
          <ul className="nav ">
            <li className="nav-item">
              <Link
                to="/"
                className="nav-link"
                onClick={() => setNavOpen(!navOpen)}
              >
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/plans"
                className="nav-link"
                onClick={() => setNavOpen(!navOpen)}
              >
                Plans
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/about"
                className="nav-link"
                onClick={() => setNavOpen(!navOpen)}
              >
                About Us
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/faq"
                className="nav-link"
                onClick={() => setNavOpen(!navOpen)}
              >
                FAQS
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/contact"
                className="nav-link"
                onClick={() => setNavOpen(!navOpen)}
              >
                Contact Us
              </Link>
            </li>
          </ul>
          <div className={`${authBtn ? "d-none" : "login-btns"}`}>
            <Link to="/login">
              <button
                className="mx-4 btn "
                onClick={() => {
                  setNavOpen(!navOpen);
                }}
              >
                LOGIN
              </button>
            </Link>
            <Link to="/register">
              <button
                className="btn btn-outline"
                onClick={() => setNavOpen(!navOpen)}
              >
                REGISTER
              </button>
            </Link>
          </div>

          <div className={`dashboard-btn ${!authBtn ? "d-none" : "d-flex"}`}>
            {/* <Link to="" onClick={logOut}>
              <div className="log-out-wrapper">
                <button className="btn btn-outline logout">
                  <i className="fas fa-sign-out-alt "></i>
                  Logout
                </button>
              </div>
            </Link> */}

            <Link to="/dashboard">
              <div className="go-to-account">
                <p>{userData.user.firstName}</p>
                <i className="user-pic fas fa-th-large mx-3"></i>
              </div>
            </Link>
          </div>
        </div>

        <button
          onClick={() => setNavOpen(!navOpen)}
          className={`nav-btn ${navOpen ? "nav-open" : ""}`}
        >
          <div className="bar-one"></div>
          <div className="bar-two"></div>
          <div className="bar-three"></div>
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
